var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09062 0.806388C1.63599 0.484357 1.00563 0.79668 0.986426 1.35348L0.519998 14.8799C0.496776 15.5533 1.34524 15.8675 1.76619 15.3413L4.85334 11.4823L8.45395 20.4839C8.60604 20.8641 9.05064 21.0331 9.41693 20.85L12.0474 19.5348C12.388 19.3645 12.53 18.9531 12.367 18.609L8.28901 9.99999H12.8705C13.5529 9.99999 13.832 9.12321 13.2752 8.72877L2.09062 0.806388Z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.249c16a89cbd3592c17f229294161417.svg";
export { ForwardRef as ReactComponent };